<template lang="html">
   <div class="test-table">
      <Table border stripe :columns="columns1" :data="data1" ref="selection" title="Hello World" :actions="actions"></Table>
      <!-- <Table border :columns="columns2" :data="data1"></Table> -->
      <!-- <Table border stripe :columns="columns1" :data="data1" height="200"></Table>
      <Table border stripe :columns="columns3" :data="data1" max-height="500"></Table> -->

      <!-- <Table border :columns="columns2" :data="data1" :search_fields="['name']" title="A New Table"></Table> -->
      <!-- <Table border :columns="columns4" :data="data1" :search_fields="['name']" title="A New Table"></Table> -->
      <!-- <Table border :columns= "columns4" :data="data1" :search_fields="['name']" title="A New Table" show-summary :summary-method="handleSummary"></Table> -->
      <!-- <Table 
         v-bind="Product.tables.product_advanced.props"
         :data="data1" 
         :summary-method="handleSummary"
      ></Table> -->
      <button class="btn btn-primary" @click="getSelection()">Edit</button>
   </div>
</template>

<script>
import product from "./resources/stores/product.store";
import expandRow from "./expand-row.vue";

export default {
   beforeDestroy() {
      this.$store.unregisterModule("product");
   },
   created() {
      utils.registerModule("product", product, this.$store);
   },
   components: {
      // Table: () => import("view-design/src/components/table"),
      Table: () => import("clarks/components/ivu-table"),
   },
   computed: {
      ...mapGetters([
         'Product',
         'products',
         'table_data',
         'loading'
      ])
   },
   data() {
      return {
         actions: [
            // {type: 'title', title: 'Actions'},
            { type: 'menu', title: 'View', event: 'product:view' },
            { type: 'menu', title: 'Edit', event: 'product:edit', icon: 'fa-edit' },
            { type: 'menu', title: 'Delete', event: 'product:delete', icon: 'fa-trash-alt' },
            { type: 'menu', title: 'Show Accounts', event: 'product:accounts', icon: 'fa-file-invoice-dollar' },
         ],
         columns2: [
            {
               type: "expand",
               width: 50,
               render: (h, params) => {
                  return h(expandRow, {
                     props: {
                        row: params.row
                     }
                  });
               }
            },
            {
               title: "Name",
               key: "name"
            },
            {
               title: "Age",
               key: "age",
               align: "center",
               sortable: true,
               filters: [
                  {
                     label: "Greater than 25",
                     value: 1
                  },
                  {
                     label: "Less than 25",
                     value: 2
                  }
               ],
               filterMultiple: false,
               filterMethod(value, row) {
                  if (value === 1) {
                     return row.age > 25;
                  } else if (value === 2) {
                     return row.age < 25;
                  }
               }
            },
            {
               title: "Address",
               key: "address"
            }
         ],
         columns1: [
            {
               type: 'selection',
               width: 60,
               align: 'center'
            },
            {
               title: "Name",
               key: "name"
            },
            {
               title: "Age",
               key: "age",
               align: "center",
               sortable: true,
               filters: [
                  {
                     label: "Greater than 25",
                     value: 1
                  },
                  {
                     label: "Less than 25",
                     value: 2
                  }
               ],
               filterMultiple: false,
               filterMethod(value, row) {
                  if (value === 1) {
                     return row.age > 25;
                  } else if (value === 2) {
                     return row.age < 25;
                  }
               }
            },
            {
               title: "Address",
               key: "address"
            }
         ],
         columns4: [
            {
               title: "Name",
               key: "name"
            },
            {
               title: "Rec",
               key: "extra.name"
            },
            {
               title: "Other",
               key: "extra.recs"
            },
            {
               title: "Age",
               key: "age",
               align: "center",
               sortable: true,
               filters: [
                  {
                     label: "Greater than 25",
                     value: 1
                  },
                  {
                     label: "Less than 25",
                     value: 2
                  }
               ],
               filterMultiple: false,
               filterMethod(value, row) {
                  if (value === 1) {
                     return row.age > 25;
                  } else if (value === 2) {
                     return row.age < 25;
                  }
               }
            },
            {
               title: "Address",
               key: "address"
            },
            {
               title: 'Action',
               key: 'action',
               width: 200,
               align: 'center',
               render: (h, params) => {
                  console.log(params)
                  return h(TableActions, {
                     props: {
                        actions: [
                           { type: 'menu', title: 'View', event: 'table:view' },
                           { type: 'menu', title: 'Delete', event: 'table:delete', icon: 'fa-trash-alt' },
                        ],
                        params: params
                     }
                  });
               }
            }
         ],
         columns3: [
            {
               title: "Name",
               key: "name",
               width: 200
            },
            {
               title: "Other",
               align: "center",
               children: [
                  {
                     title: "Age",
                     key: "age",
                     align: "center",
                     sortable: true,
                     width: 300,
                     filters: [
                        {
                           label: "Greater than 25",
                           value: 1
                        },
                        {
                           label: "Less than 25",
                           value: 2
                        }
                     ],
                     filterMultiple: false,
                     filterMethod(value, row) {
                        if (value === 1) {
                           return row.age > 25;
                        } else if (value === 2) {
                           return row.age < 25;
                        }
                     }
                  },
                  {
                     title: "Address",
                     align: "center",
                     children: [
                        {
                           title: "Street",
                           key: "street",
                           align: "center",
                           width: 200
                        },
                        {
                           title: "Block",
                           align: "center",
                           children: [
                              {
                                 title: "Building",
                                 key: "building",
                                 align: "center",
                                 width: 200,
                                 sortable: true
                              },
                              {
                                 title: "Door No.",
                                 key: "door",
                                 align: "center",
                                 width: 200
                              }
                           ]
                        }
                     ]
                  }
               ]
            },
            {
               title: "Address",
               key: "address",
               width: 500
            }
         ],
         data1: [
            {
               name: "John Brown",
               age: '18',
               address: "New York No. 1 Lake Park",
               date: "2016-10-03",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jim Green",
               age: 24,
               address: "London No. 1 Lake Park",
               date: "2016-10-01",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
               // children: [
               //    {
               //       name: 'Joe Black',
               //       age: 30,
               //       address: 'Sydney No. 1 Lake Park',
               //       date: '2016-10-02'
               //    },
               //    {
               //       name: 'Jon Snow',
               //       age: 26,
               //       address: 'Ottawa No. 2 Lake Park',
               //       date: '2016-10-04'
               //    }
               // ]
            },
            {
               name: "Joe Black",
               age: 30,
               address: "Sydney No. 1 Lake Park",
               date: "2016-10-02",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Joe Black",
               age: 30,
               address: "Sydney No. 1 Lake Park",
               date: "2016-10-02",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Joe Black",
               age: 30,
               address: "Sydney No. 1 Lake Park",
               date: "2016-10-02",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Joe Black",
               age: 30,
               address: "Sydney No. 1 Lake Park",
               date: "2016-10-02",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            },
            {
               name: "Jon Snow",
               age: 26,
               address: "Ottawa No. 2 Lake Park",
               date: "2016-10-04",
               extra:{
                  name: 'Hello',
                  recs: [
                     {
                        name: 'Other'
                     }
                  ]
               },
               job: "Data Scientist",
               interest: "volleyball",
               birthday: "1989-03-18",
               book: "My Struggle",
               movie: "Roman Holiday",
               music: "My Heart Will Go On"
            }
         ]
      };
   },
   methods: {
      onEmptyData() {},
      refreshData() {},
      handleSummary ({ columns, data }) {
         const sums = {};
         columns.forEach((column, index) => {
            const key = column.key;
            if (index === 0) {
               sums[key] = {
                  key,
                  value: 'Totals'
               };
               return;
            }

            const values = data.map(item => Number(item[key]));
            if (!values.every(value => isNaN(value))) {
               const v = values.reduce((prev, curr) => {
                     const value = Number(curr);
                     if (!isNaN(value)) {
                        return prev + curr;
                     } else {
                        return prev;
                     }
               }, 0);
               sums[key] = {
                     key,
                     value: v + ''
               };
            } else {
               sums[key] = {
                     key,
                     value: 'N/A'
               };
            }
         });

         return sums;
      },
      getSelection() {
         console.log(this.$refs.selection.getSelection())
      }
   },
   mounted() {
      utils.registerModule("product", product, this.$store);
   }
};
</script>

<style lang="scss">
.test-table {
   padding: 20px;
}
</style>
